import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'

import styles from './styles.css'

export default class FormBody extends PureComponent {
  static propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    children: PropTypes.node.isRequired,
  }

  render() {
    const { children, buttons, style, ...props } = this.props

    return (
      <div {...props} style={{ display: 'flex', flex: 1, flexDirection: 'column', ...style }}>
        <div style={{ flex: 1 }}>{children}</div>
        <div>
          {buttons.map(button => (
            <button
              key={button.label}
              onClick={button.onClick}
              className={classnames(styles.button)}
            >
              {button.label.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/formBody/index.js